const resendGestorInvite = async (token: string, companyId: string, managementUserId: string) => {
	const response = await fetch(
		`${process.env.REACT_APP_BASE_API}/users/${companyId}/management/${managementUserId}/resend-invite`,
		{
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`
			}
		}
	);

	if (!response.ok) {
		const errorBody = await response.json().catch(() => ({}));
		throw new Error(errorBody.message || `Error ${response.status}`);
	}

	return response.json();
};

export default resendGestorInvite;
